import { putUserEmergencyContact } from '@uplift/api';
import { VALIDATION_EMERGENCY_CONTACT_NAME, VALIDATION_EMERGENCY_CONTACT_PHONE, VALIDATION_EMERGENCY_CONTACT_RELATIONSHIP } from '@uplift/validations';
import * as Yup from 'yup';
import { SettingsFormSubmissionOptions } from '../types';

export type EmergencyContactFormType = {
  name: string;
  relationship: string;
  phone: string;
};

export const useEmergencyContactForm = (
  userId: string,
  emergencyContact: Partial<EmergencyContactFormType> | undefined,
  options?: SettingsFormSubmissionOptions
) => {
  const emergencyContactFormik = () => {
    const initialValues: EmergencyContactFormType = {
      name: emergencyContact?.name || '',
      relationship: emergencyContact?.relationship || '',
      phone: emergencyContact?.phone || '',
    };

    const validationSchema = Yup.object({
      name: VALIDATION_EMERGENCY_CONTACT_NAME,
      relationship: VALIDATION_EMERGENCY_CONTACT_RELATIONSHIP,
      phone: VALIDATION_EMERGENCY_CONTACT_PHONE
    });

    const onSubmit = async (values: EmergencyContactFormType) => {
      try {
        await putUserEmergencyContact(userId, values);

        options?.onFormSubmitSuccess();
      } catch (error) {
        if (options?.onFormSubmitError) {
          options.onFormSubmitError();
        } else {
          throw error;
        }
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { emergencyContactFormik };
};